import type React from 'react'

import { DescriptionWrapper } from '../DescriptionWrapper'

export const DescriptionPro: React.FC = () => (
  <DescriptionWrapper>
    Save <b>$24</b> Every Year.
    <br /> More focus, less billing.
  </DescriptionWrapper>
)
